// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e86eed3c","553":"56a5f1ae"}[chunkId] + ".chunk.js";
};